import { addresses as addressesApi } from '@afosto/contacts/api/Addresses';

const fetchAddress = async addressId => {
  try {
    const response = await addressesApi.viewAddress(addressId);
    const { data = {} } = response;

    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export default fetchAddress;
